<template>
    <div id="modal-particulars" class="modal fade" role="dialog" data-backdrop="static">
        <div class="modal-dialog">
            <!-- Modal content-->
            <div class="modal-content">
                <div class="modal-header">
                    <h4 class="modal-title">Particulars</h4>
                </div>
                <div class="modal-body"> 
                    <textarea class="form-control"  rows="5" v-model="item_particulars"></textarea>
                </div>
                <div class="modal-footer">
                    <button type="button" class="btn btn-success" data-dismiss="modal" @click="submitAccess">Save &amp; Close</button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    props: ['callback', 'selected_particular'], //readonly
    data() { //read and write
        return {
            item_particulars: ''
        }
    },
    methods: {
        submitAccess() {
            this.callback(this.item_particulars);
        },
        clearAll() {
            this.item_particulars = ''
        }
    },
    watch: {
        "selected_particular": function() {
            this.item_particulars = this.selected_particular;
        }
    }
}
</script>